import { render } from "./Tabs.component.vue?vue&type=template&id=072a2d9e&ts=true"
import script from "./Tabs.component.vue?vue&type=script&lang=ts"
export * from "./Tabs.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__